import React from "react";

export default function About() {
        return (
                <section id="about" className="bg-black">
                        <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
                                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                                        <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
                                                Hi, I'm Christina Delancy.
                                                <br className="hidden lg:inline-block sm:inline-block"/> I love to
                                                build amazing apps.
                                        </h1>
                                        <p className="mb-8 leading-relaxed">
                                                I'm a Brooklyn-based developer who creates responsive websites and applications for small businesses, nonprofits, and enterprise teams. My work spans HTML5, CSS, JavaScript, React.js, Node.js, and SQL, and I enjoy delivering documentation, maintenance, and technical support that help clients grow.
                                                <br />
                                                <br />
                                                Recently I served as a Developer at Deepwatch, building reusable React and TypeScript components, conducting peer code reviews, and collaborating with cross-functional teams to deliver enterprise applications. Before that I worked as an Associate Developer at Deepwatch, implementing front-end features, testing frameworks, and participating in Agile development cycles.
                                                <br />
                                                <br />
                                                I completed Fullstack Academy's Future Code program, building full-stack applications and deepening my expertise in JavaScript, React, Node.js, and PostgreSQL.
                                                <br />
                                                <br />
                                                I look forward to leveraging my skills to support diverse communities through accessible technology.
                                        </p>
                                        <div className="flex justify-center">
                                                <a
                                                        href="#contact"
                                                        className="inline-flex text-white bg-red-700 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg text-center"
                                                >
                                                        Contact Me
                                                </a>
                                                <a
                                                        href="#projects"
                                                        className="ml-4 inline-flex text-black bg-silver border-0 py-2 px-6 focus:outline-none hover:bg-red-600 hover:text-white rounded text-lg text-center"
                                                >
                                                        See My Past Work
                                                </a>
                                        </div>
                                        <div className="flex flex-row content-center mt-4">
                                                <h5 className="title-font sm:text-2xl text-xl mb-4 font-medium text-white text-base pt-4 mt-4 align-middle">
                                                        Follow Me On:
                                                </h5>
                                                <a
                                                        className="w-20 h-20 m-4 border-4 border-silver bg-white hover:border-red-800"
                                                        href="https://github.com/CDelancy19"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                >
                                                        <img src="/Github-Mark.png" alt="Link to Github" />
                                                </a>
                                                <a
                                                        className="w-20 h-20 m-4 border-4 border-silver bg-white hover:border-red-800"
                                                        href="https://www.linkedin.com/in/cdelancy11/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                >
                                                        <img src="/LinkedIn-Mark.png" alt="Link to LinkedIn" />
                                                </a>
                                        </div>
                                </div>
                                <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 bg-silver">
                                        <img
                                                className="object-cover object-center rounded"
                                                alt="hero"
                                                src="./coding.svg"
                                        />
                                </div>
                        </div>
                </section>
        );
}



// WEBPACK FOOTER //
// ./src/components/About.js